<template>
    <div
        v-if="sessionExpired"
        ref="modalBackdrop"
        class="fixed inset-0 z-9999 flex items-center justify-center bg-black/60"
    >
        <div
            ref="focusTrapContainer"
            role="dialog"
            aria-live="assertive"
            aria-modal="true"
            :aria-label="localizations[lang].sessionValidExpired"
            class="m-4 w-[400px] rounded-lg bg-theme-bg shadow-lg sm:w-[480px] md:w-[425px]"
        >
            <div
                ref="modalContent"
                class="w-full p-5 text-lg leading-relaxed text-theme-text transition-[font-size] duration-100 ease-in-out"
            >
                <div class="mx-auto flex h-full items-center justify-center px-0">
                    <div class="flex w-full flex-col items-center justify-center">
                        <div class="mt-0 flex w-full flex-col items-center space-y-3 px-4">
                            <div class="flex w-full flex-row items-center space-x-2">
                                <svg-icon
                                    class="text-theme-icon"
                                    icon="exclamation-circle"
                                    width="24px"
                                    height="24px"
                                />
                            </div>

                            <p class="mb-0 w-full text-sm font-bold sm:text-sm md:text-base">
                                {{ localizations[lang].sessionValidExpired }}
                            </p>

                            <p class="w-full text-xs sm:text-xs md:text-sm">
                                {{ localizations[lang].sessionValidExpiredPleaseLoginAgain }}
                            </p>

                            <div class="flex w-full items-center justify-end text-sm">
                                <button class="closeButtonTw" @click.prevent="closeVolpe">
                                    {{ localizations[lang].tooltips.close }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { uiAPI } from '../../../src/js/communication';
import focusTrapMixin from '../../js/mixins/focusTrapMixin';

export default {
    name: 'SessionExpiredModal',
    mixins: [focusTrapMixin],
    data() {
        return {
            focusTrapEnabled: false,
        };
    },
    computed: {
        ...mapState(['lang', 'localizations', 'sessionExpired']),
    },
    watch: {
        sessionExpired: {
            immediate: true,
            handler(isExpired) {
                this.focusTrapEnabled = isExpired;
            },
        },
    },
    mounted() {},
    methods: {
        onFocusTrapEscape() {
            this.closeVolpe();
        },
        closeVolpe() {
            uiAPI.close();
        },
    },
};
</script>
